<template>
  <div>
      <h3>Puzzling Sessions</h3>
      <v-dialog
          v-model="dialog"
          width="100%"
          max-width="400">
        <template v-slot:activator="{ on, attrs }" >
          <v-btn class="blue white--text" v-bind="attrs" small
                 v-on="on">Start Session</v-btn>
        </template>

        <v-card>
          <v-container class="align-center">
          </v-container>

        </v-card>
      </v-dialog>
    <div class="d-flex">
      <div>
        <v-icon>mdi-puzzle-check</v-icon>
      </div>
      <div> Date - 00:01:12 </div>
    </div>

  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
  name: 'puzzling_sessions',
  components: {
  },
  computed: {
    ...mapState({
      puzzleHistories: 'puzzleHistories'
    }),

    ...mapGetters({
      subscriptionStatus: 'getSubscriptionStatus',
    }),
  },
  watch: {
    'puzzleOrderId': function(){
      for (let index in Object.keys(this.puzzleHistories)) {
        if (this.puzzleHistories[index].attributes.puzzleOrderId == puzzleOrderId){
          this.puzzleHistory = this.puzzleHistories[index]
          //dispatch to get sessions
        }
      }
    }
  },
  methods: {
    confirmAcceleration: function(){
      this.dialog = false;
    }

  },
  data: function(){
    return {
      dialog: false,
      puzzleHistory: null
    }
  },
  props: {
    puzzleHistoryId: null,
    puzzleOrderId: null
  }
}
</script>
<style scoped>
.pointer-hover {
  cursor: pointer;
}
.feature-highlight {
  background-color: #FBE639 !important;
}
.feature-highlight > .v-card__text {
  color: rgba(0,0,0,.87) !important;
}
.negative-margin {
  margin: -16px;
  margin-right: 0px;
}
</style>
